import React, { Component } from "react";

class TeamSettings extends Component {
  state = {
    title: this.props.title
  };

  handleTitleChange = e => {
    this.setState({ title: e.target.value });
  };

  render() {
    const { title } = this.state;
    return (
      <div className="form-group">
        <label htmlFor="recipient-name" className="control-label">
          Titre:
        </label>
        <input
          type="text"
          className="form-control"
          value={title}
          onChange={this.handleTitleChange}
        />
      </div>
    );
  }
}

export default TeamSettings;
